module.exports = __webpack_public_path__ + "img/Specifications-Img-Vacuum-40-min-1.0591186c.0cbf3bf2.png";